import React, { useCallback } from 'react';
import getSetCookie from '../../../../cookie';
import './Footer.scss';

function onNeedHelpClickHandler(
  history,
  id,
  email,
  telephone,
  sprinklrBotEnabled,
  freshBotEnabled,
  countryCode
) {
  if (sprinklrBotEnabled === 'ON') {
    const { chatBotParams } = window;
    if (chatBotParams) {
      chatBotParams.orderNo = id || '';
      chatBotParams.emailId = email || '';
      chatBotParams.phoneNumber = telephone || '';
      chatBotParams.sessionID = getSetCookie.getCookie(`clientV1_${countryCode}`) || '';
      chatBotParams.env = process.env.BUILD_ENV === 'development' ? 'preprod' : 'prod';
      chatBotParams.apiClient = process.env.CLIENT_TYPE;
    }
    // window.Freshbots?.reloadContext();
    window.setTimeout(() => {
      // window.Freshbots?.initiateChat();
      // window.Freshbots?.showWidget(true);
      window &&
        window.sprChat &&
        window.sprChat('openNewConversation', {
          conversationContext: {
            _c_6216101a55e837709d0a6190: [id], // order ID from each need help button
            _c_62a1a4e3d7c1ad35cd4ae0d8: ['TRUE'], // triggeredByOrderButton
          },
          initialMessages: [{ message: 'Need Help', isSentByUser: true }],
          id, // MANDATORY, order ID from each need help button
          // autoInitiateConversation: true
        });
    }, 2000);
  } else if (freshBotEnabled === 'ON') {
    const { chatBotParams } = window;
    if (chatBotParams) {
      chatBotParams.orderNo = id || '';
      chatBotParams.emailId = email || '';
      chatBotParams.phoneNumber = telephone || '';
      chatBotParams.sessionID = getSetCookie.getCookie(`clientV1_${countryCode}`) || '';
      chatBotParams.env = process.env.BUILD_ENV === 'development' ? 'preprod' : 'prod';
      chatBotParams.apiClient = process.env.CLIENT_TYPE;
    }
    window.Freshbots?.reloadContext();
    window.setTimeout(() => {
      window.Freshbots?.initiateChat();
      window.Freshbots?.showWidget(true);
    }, 2000);
  } else {
    history.push('/cms-queries');
  }
}

function Footer(props) {
  const {
    history,
    listing,
    order: { id },
    getOrderDetails,
    userInfo: { email, telephone, countryCode } = {},
    freshBotEnabled,
    sprinklrBotEnabled,
    needHelpListingEnabled,
    dataLocale: { NEED_HELP, ORDER_DETAILS },
  } = props; // { order: status: { returnable }, refundExchangeInfoFunc, dataLocale: { EXCHANGE_REFUND } }
  let goToOrderDetailsFunc;
  let needHelpFunc;
  if (listing) {
    goToOrderDetailsFunc = useCallback(() => {
      getOrderDetails(id);
      getSetCookie.setCookie('isReturnExOld', true, 0.5);
    }, []);
  }
  if (needHelpListingEnabled === 'ON' || !listing) {
    needHelpFunc = useCallback(
      onNeedHelpClickHandler.bind(
        null,
        history,
        id,
        email,
        telephone,
        sprinklrBotEnabled,
        freshBotEnabled,
        countryCode
      ),
      []
    );
  }
  return (
    <div className="order-footer margin-t15 display-flex justify-space-between float-right">
      {typeof needHelpFunc === 'function' && (
        <button
          aria-label="Click here for help"
          className="btn bg-color-white fs14 bora-4 padding-12 lh-16 text-color-66"
          onClick={needHelpFunc}
        >
          {NEED_HELP}
        </button>
      )}
      {listing && (
        <button
          aria-label="Click here to see your order details"
          className={`btn bg-color-white fs14 bora-4 padding-12 lh-16 text-color-66 ${
            listing && typeof needHelpFunc === 'function' ? 'margin-l15' : ''
          }`}
          onClick={goToOrderDetailsFunc}
        >
          {ORDER_DETAILS}
        </button>
      )}
      {/* Hide Exchange Refund button */}
      {/* {!listing && returnable && <button onClick={refundExchangeInfoFunc} aria-label="Click here for exchange or refund" className="btn exchange-btn margin-l15 bg-color-white fs14 bora-4 padding-12 lh-16 text-color-primary">{EXCHANGE_REFUND}</button>} */}
    </div>
  );
}

export default Footer;
